// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.floorplans.photos.RentalManagerUserPropertyFloorPlanPhotoWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_deleteForFeed,
  RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload,
  RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_uploadForFeed,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  ListingAlias,
  UserPropertyFloorPlanPhotoDeleteForFeedRequestWebDto,
  UserPropertyFloorPlanPhotoUploadRequestWebDto,
  UserPropertyFloorPlanPhotoUploadResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface UploadParams {
  floorPlanId: string;
  sourceUrl?: string;
}
interface UploadForFeedParams {
  floorPlanId: string;
  listingAlias: ListingAlias;
  sourceUrl?: string;
}

export interface RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_deleteForFeed_Args {
  postData: UserPropertyFloorPlanPhotoDeleteForFeedRequestWebDto;
}

export type RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_deleteForFeed_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_deleteForFeed_Args
>;

/**
 * Delete an uploaded photo from a floor plan of a feed listing
 */
export const useRentalManagerUserPropertyFloorPlanPhotoWebApiHandler_deleteForFeed = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_deleteForFeed_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_deleteForFeed_Args) =>
      RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_deleteForFeed(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload_Args {
  getParams: UploadParams;
  postData: UserPropertyFloorPlanPhotoUploadRequestWebDto;
}

export type RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload_Options = UseMutationOptions<
  UserPropertyFloorPlanPhotoUploadResponseWebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload_Args
>;

/**
 * Upload a photo for a floor plan
 */
export const useRentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload_Args) =>
      RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload(args.getParams, args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_uploadForFeed_Args {
  getParams: UploadForFeedParams;
  postData: UserPropertyFloorPlanPhotoUploadRequestWebDto;
}

export type RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_uploadForFeed_Options = UseMutationOptions<
  UserPropertyFloorPlanPhotoUploadResponseWebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_uploadForFeed_Args
>;

/**
 * Upload a photo onto a floor plan of a feed listing
 */
export const useRentalManagerUserPropertyFloorPlanPhotoWebApiHandler_uploadForFeed = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_uploadForFeed_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_uploadForFeed_Args) =>
      RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_uploadForFeed(args.getParams, args.postData, httpClient),
  });
};
